export default interface IConnectDeviceViewData {
    ftpUri: string,
    items: string[]
}

export class ConnectDeviceViewData implements IConnectDeviceViewData {
    ftpUri: string;
    items: string[];

    constructor(ftpUri:string, items: string[]) {
        this.ftpUri = ftpUri;
        this.items = items;
    }
}

const defaultConnectDeviceViewData = new ConnectDeviceViewData("", []);
export { defaultConnectDeviceViewData } 